/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_All_GroupsInputs */

const vi_customer_all_groups = /** @type {(inputs: Customer_All_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả nhóm`)
};

/**

* @param {Customer_All_GroupsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_all_groups = /** @type {((inputs?: Customer_All_GroupsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_All_GroupsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_all_groups(inputs)
});